import { createTheme, Grid, MuiThemeProvider, Typography } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import React from 'react';
import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import getDefaultGridOptions from '../../../utils/componentUtils';
import { useStyles } from '../Style';
type props = any;

const MvmOutgoingInvoiceRequestLogList: React.FC<props> = ({ control, name  }) => {

    const classes = useStyles();
    const { t } = useTranslation("Mvm");
    const { t: _t } = useTranslation("General");
    const { fields } = useFieldArray({ control, name: name });

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''
                }
            }
        }
    })

    const columns = [
        {
            name: 'logDate',
            label: String(t('logDate')),
            options: {
                sort: true,
                setCellProps: () => ({
                    align: "left"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    var date = new Date(value)
                    return (`${date.toLocaleDateString()} ${date.toLocaleTimeString()}`);
                }
            }
        },
        {
            name: 'logTypeDescription',
            label: String(t('logType')),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'createdBy',
            label: String(t('logUser')),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })               
            }
        }
    ] 
  
    return (
        <Grid style={{ marginTop: 20, width: "98%", marginLeft: 10, marginBottom: 10 }}>
            <Typography className={classes.root} style={{ marginLeft: 0, marginBottom: 10 }} >
                {t("logs")}
            </Typography>            
            <MuiThemeProvider theme={myTheme} >
                <MUIDataTable
                    title=""
                    data={fields}
                    columns={columns}
                    options={{
                        ...getDefaultGridOptions(_t),
                        serverSide: false,
                        pagination: false,
                        sortOrder: {
                            name: 'logDate',
                            direction: 'desc'
                        },
                        selectToolbarPlacement: "none",
                        filter: false,
                        search: false,
                        download: false,
                        print: false,
                        viewColumns: false,
                        selectableRows: 'none',
                    }}
                />
            </MuiThemeProvider>
        </Grid>
    )
}

export default MvmOutgoingInvoiceRequestLogList

